import { render, staticRenderFns } from "./HorizontalContainer.vue?vue&type=template&id=2b3aa64a&scoped=true"
import script from "./HorizontalContainer.vue?vue&type=script&lang=js"
export * from "./HorizontalContainer.vue?vue&type=script&lang=js"
import style0 from "./HorizontalContainer.vue?vue&type=style&index=0&id=2b3aa64a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3aa64a",
  null
  
)

export default component.exports